import { Dialog, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Schema from 'generated/graphql/schema';
import { FC } from 'react';

import CreatePeripheralContent, { RequiredDeviceFields } from './create-peripheral-content';

export interface Properties {
  softwareId: string | undefined;
  device?: RequiredDeviceFields;
  groups: Schema.AdministrationDetailedGroupsQuery['company']['groups'];
  companyId: string | undefined;
  open: boolean;
  onClose?: () => unknown;
  onDone: () => void;
}

const CreatePeripheralDialog: FC<Properties> = (props) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog fullScreen={fullScreen} open={props.open} onClose={props.onClose} fullWidth maxWidth="sm">
      <CreatePeripheralContent {...props} />
    </Dialog>
  );
};

export default CreatePeripheralDialog;
